<template>
  <router-link class="preview" :to="link">
    <div class="preview__image" :style="styleObject">
    </div>
    <div class="preview__title">
      {{title}}
    </div>
    <div class="preview__description">
      {{description}}
    </div>
  </router-link>
</template>

<script>

export default {
  name: 'Preview',
  props: {
    src: String,
    title: String,
    description: String,
    link: Object,
  },
  computed: {
    styleObject() {
      return {
        backgroundImage: `url(${this.src})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  display: block;
  text-decoration: none;
  &__image {
    width: 100%;
    height: 180px;
    border: solid 3px var(--color-dark);
    border-radius: var(--radius);
    margin-bottom: 10px;
    background-size: cover;
    background-repeat: no-repeat;
    @media all and (max-width: 600px) {
      height: 130px;
    }
  }
  &__title {
    font-weight: 500;
    color: var(--color-dark);
  }
  &__description {
    color: var(--color-link-inactive);
  }
  &:hover {
    .preview__image {
      border-color: var(--color-link);
    }
    .preview__title {
      color: var(--color-link);
    }
  }
}
</style>
